export default __webpack_public_path__ + "static/media/Sunrise-Multispeciality-Hospital.c481b565.png";